const pallet = {
    white: '#fff',
    black: '#000',
    clear: '#00000000',
    red: '#ff3b30',
    purple: '#211f57',
    lightGreen: '#C8E6C9', // material green 100
    green: '#1B5E20', // material green 900
    lighestGray: '#efeff4',
    lightGray: '#e0e0e0', // material gray 300
    medGray: '#757575', // material gray 600
    darkGray: '#212121', // material gray 900
    lightBlue: '#00b9f7',
    cautionBlue: '#2888ff',
    darkBlue: '#363c4b'
};

const colors = {
    // pallet
    white: pallet.white,
    black: pallet.black,
    clear: pallet.clear,
    lightGray: pallet.lightGray,
    medGray: pallet.medGray,
    darkGray: pallet.darkGray,
    lightBlue: pallet.lightBlue,
    darkBlue: pallet.darkBlue,
    cautionBlue: pallet.cautionBlue,
    lightGreen: pallet.lightGreen,
    green: pallet.green,
    red: pallet.red,
    // base UI
    background: pallet.lighestGray,
    navigationBarBackground: pallet.lightBlue,
    navigationBarText: pallet.white,
    navigationBarButtonText: pallet.white,
    loadingSpinner: pallet.lightBlue,
    grayText: pallet.medGray,
    errorText: pallet.red,
    webLink: pallet.lightBlue,
    rowHighlight: pallet.lightBlue,
    // bottom tabs
    tabBarActive: pallet.lightBlue,
    tabBarInactive: pallet.medGray,
    // inner tabs
    innerTabViewTabBackground: pallet.white,
    innerTabViewTabText: pallet.darkGray,
    innerTabViewTabIndicator: pallet.lightBlue,
    // subtitle
    subtitleBackground: pallet.white,
    subtitleBorder: pallet.lightGray,
    subtitleText: pallet.darkBlue,
    subtitleSubText: pallet.medGray,
    subtitleBackButton: pallet.darkBlue,
    // sub navbar
    subNavBackground: pallet.white,
    subNavBorder: pallet.lightGray,
    subNavText: pallet.darkGray,
    subNavBackButton: pallet.lightBlue,
    // rows
    rowPrimaryText: pallet.darkGray,
    rowSecondaryText: pallet.medGray,
    rowSeparator: pallet.lightGray,
    // rows: articles
    rowArticleSubtitle: pallet.medGray,
    rowArticleImagePlaceholderBorder: pallet.lightGray,
    // rows: player news
    rowPlayerNewsPlayerName: pallet.darkGray,
    rowPlayerNewsTeamName: pallet.medGray,
    rowPlayerNewsTitle: pallet.darkGray,
    rowPlayerNewsDate: pallet.medGray,
    // controls
    primaryButtonBackground: pallet.lightBlue,
    primaryButtonText: pallet.white,
    secondaryButtonBorder: pallet.lightBlue,
    secondaryButtonText: pallet.lightBlue
};

export default colors;



// WEBPACK FOOTER //
// ./src/assets/values/colors.js